import LoadingPlus from "./index.vue"
const obj = {}

obj.install = function(Vue) {
  // console.log("我执行了")
  // 1、创建组件构造器
  const loadingPlusConstructor = Vue.extend(LoadingPlus)
  // 2、根据构造器通过new的方式可以创建出一个组件实例
  const _loadingPlus = new loadingPlusConstructor()
  // 3、将组件对象手动挂载到某一个元素上采用$mount
  _loadingPlus.$mount(document.createElement("div"))
  // 4、_yloadingPlus.$el对应的就是这个div，将它添加到body中
  document.body.appendChild(_loadingPlus.$el)
  // 5、绑定到vue的原型链上
  Vue.prototype.$Loading = _loadingPlus
}

export default obj